import { CaptionText, DoubleLineCellWrapper, TitleText } from './Styled';

type DoubleLineCellProps = {
  title: string;
  subTitle: string;
};

export const DoubleLineCell = ({ title, subTitle }: DoubleLineCellProps) => {
  return (
    <DoubleLineCellWrapper>
      <TitleText>{title}</TitleText>
      <CaptionText>{subTitle}</CaptionText>
    </DoubleLineCellWrapper>
  );
};
